module.exports = __webpack_public_path__ + "companyDefault.png?392a537ec8ee710b4a87719e2e7b3074";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/companyDefault.png
// module id = 130
// module chunks = 2